module.exports = __webpack_public_path__ + "static/img/fenzuhanhua.b8196cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/fenzuhanhua.png
// module id = fAt5
// module chunks = 24